import { render, staticRenderFns } from "./visit.vue?vue&type=template&id=0fba07e8&scoped=true&"
import script from "./visit.vue?vue&type=script&lang=js&"
export * from "./visit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fba07e8",
  null
  
)

export default component.exports